/**
 * TODO:
 * delete later when tertiary and quaternary colors implemented
 */

/**
 * savoyAdjustBasedColor, adjust color based on Savoy Template (pba-template4)
 * @param cssVars a css variable object from useSetting.cssVars
 * @param hotelId hotel id
 * @returns object
 */
export function savoyAdjustBasedColor(cssVars: object, hotelId?: string | number) {
  switch (Number(hotelId)) {
    case 137: // SAVOY BORACAY
      cssVars['--color-tertiary'] = '#9A5CA4'
      cssVars['--color-quaternary'] = '#7A9C44'
      break
    case 138: // SAVOY MACTAN
      // NOTE: others tertiary color: #CF432D
      cssVars['--color-tertiary'] = '#F5Cf3E'
      cssVars['--color-quaternary'] = '#7A9C44'
      break
    case 144: // SAVOY MANILA
      cssVars['--color-tertiary'] = '#F0D72F'
      cssVars['--color-quaternary'] = '#9A5CA4'
      break
    default: // USE SAVOY MANILA AS DEFAULT COLOR
      cssVars['--color-tertiary'] = '#F0D72F'
      cssVars['--color-quaternary'] = '#9A5CA4'
      break
  }

  return {
    primary: cssVars['--color-primary'],
    secondary: cssVars['--color-secondary'],
    tertiary: cssVars['--color-tertiary'],
    quaternary: cssVars['--color-quaternary'],
  }
}
